class Veiculo {
  veiculoProprio = false;
  intPessoaId = null;
  placa = null;
  ufLicenciamento = null;
  renavam = null;
  tipo = null;
  tipoRodado = null;
  tipoCarroceria = null;
  tara = null;
  capacidadeKg = null;
  capacidadeM3 = null;
  rntcProprietario = null;

  constructor(veiculo) {
    this.veiculoProprio = veiculo.veiculoProprio;
    if (!veiculo.veiculoProprio) {
      this.intPessoaId = veiculo?.intPessoaId;
    }
    this.placa = veiculo.placa;
    this.ufLicenciamento = veiculo.ufLicenciamento;
    this.renavam = veiculo.renavam;
    this.tipo = veiculo.tipo;
    if (veiculo.tipo == "VEICULO") {
      this.tipoRodado = veiculo.tipoRodado;
    }
    this.tipoCarroceria = veiculo.tipoCarroceria;
    this.tara = veiculo.tara;
    this.capacidadeKg = veiculo.capacidadeKg;
    this.capacidadeM3 = veiculo.capacidadeM3;
    this.rntcProprietario = veiculo.rntcProprietario;
  }
}

export default Veiculo;
